import { useCallback, useEffect, useState } from "react";
import { Col, Nav, Row, Tab } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import '../../../Airoom.css';
import DateComp from "../../../core/common/dateComponent/DateComp";
import TableLoading from "../../../core/common/loadingComponent/TableLoading";
import NoRecordFound from "../../../core/common/noRecord/NoRecordFound";
import Pagination from "../../../core/common/pagination/Pagination";
import Ribbon, { ToggleButton } from "../../../core/common/ribbon/ribbon";
import CustomSelect from "../../../core/common/selectPirority/SelectPirority";
import TextField from "../../../core/common/textFields/TextField";
import { useTableSelection } from "../../../core/hooks/useTableSelection";
import { useGetAllUsersQuery } from "../../../services/EndPointsApis";
import '../../../style/css/index.css';
import { svgIcons } from "../../../style/fonts/SvgIcons";
import ActiveUserModal from "./ActiveUserModal";
import AddUpdateUserModal from "./AddUpdateUserModal";
import FilterModalUser from "./FilterModalUser";
import FilterComponent from "../../../core/common/FilterComponent";
import { debounce } from "lodash";
import TableHeading from "../../../core/common/tableHeading/TableHeading";
import ErrorBoundary from "antd/es/alert/ErrorBoundary";
import { CSVLink } from "react-csv";
import { initialColumnUsers } from "./initialColumnUsers";
import dayjs from "dayjs";

const Manageusers = () => {
  const formattedDate = dayjs().format("YYYY-MM-DD_HH-mm-ss");

  const [adduser, setAdduser] = useState(false);
  const [showfilterModal, setShowfilterModal] = useState(false);
  const [currentToggleState, setCurrentToggleState] = useState(false);
  const [showAddUpdateUserModal, setShowAddUpdateUserModal] = useState(false)
  const [showActiveUserModal, setShowActiveUserModal] = useState(false)
  const [viewOnly, setViewOnly] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [isRowClicked, setIsRowClicked] = useState(false)
  const [pageNumber, setPageNumber] = useState(1)
  const [pageSize, setPageSize] = useState(15);
  const [searchStr, setSearchStr] = useState('');
  const [sortBy, setSortBy] = useState("createDT");
  const [sortOrder, setSortOrder] = useState("desc");
  const [sortedColumn, setSortedColumn] = useState("createDT");
  const [immediateSearchStr, setImmediateSearchStr] = useState('')

  const { data: allUsers, isLoading: allUserIsloading, refetch } = useGetAllUsersQuery({
    pageNumber: pageNumber,
    pageSize: pageSize,
    searchStr: searchStr || '',
    sortBy: sortBy,
    sortOrder: sortOrder,
  }); 

  //get alluser Api

  const { data: allUsersCSV } = useGetAllUsersQuery({
    pageNumber: pageNumber,
    pageSize: pageSize,
    searchStr: searchStr || '',
    sortBy: sortBy,
    sortOrder: sortOrder,
  });
  const navigate = useNavigate()
  const handlePageSizeChange = (selectedOption: any) => {
    setPageSize(selectedOption.value);
    setPageNumber(1); 
  };

  // pagination
  const handlePageClick = (e: any) => {
    setPageNumber(e.selected + 1);
  };

  //per page record
  const handlePageRecords = (e: any) => {
    setPageNumber(1); 
  };
  const handleSort = (property: string) => {
    setSortBy(property);
    if (sortedColumn === property) {
      setSortOrder(prevSortOrder => (prevSortOrder === "asc" ? "desc" : "asc"));
    } else {
      setSortedColumn(property);
      setSortOrder("asc");
    }
  };

  //Search
  const handleSearchChange = (e: any) => {
    const { value } = e.target;
    setImmediateSearchStr(value);
    delayedSearch(value);
  };

  const delayedSearch = useCallback(
    debounce((searchValue) => {
      setSearchStr(searchValue);
    }, 500),
    []
  );
  useEffect(() => {
    if (searchStr === "" ||
      sortOrder === "" ||
      sortBy === "") {
      refetch();
    }
  }, [searchStr, sortOrder, sortBy]);



  const {
    isTableHeadChecked,
    selectedIndividualCheckboxId,
    selectedItemData: UserData,
    handleTableHeadChange,
    handleCheckItem,
    handleRowClick,
    handleRowDoubleClick,
    handleDelete,
    setSelectedItemData,
    setSelectedIndividualCheckboxId
  } = useTableSelection(allUsers?.result?.value.result?.data || [], 'userAccountId');

  const idValue = 'dropdownMenuClickableInsise1';

  const handlefiltermodel = () => {
    setShowfilterModal(true);
    const dropdownToggle = document.getElementById(idValue);
    if (dropdownToggle) {
      dropdownToggle.click();
    }
  }

  const isAnyCheckboxChecked = selectedIndividualCheckboxId.length > 0;
  const isMoreThanOneChecked = selectedIndividualCheckboxId.length > 1;
  const [userData, setUserData] = useState({})

  const handleClosefilterModal = () => {
    setShowfilterModal(false)
  };

  const handleDoubleClick = (items: any) => {    
    handleRowDoubleClick(items);
    setViewOnly(true);
    setShowAddUpdateUserModal(true);
  };

  const handleToggle = () => {
    const newToggleState = !currentToggleState;
    setCurrentToggleState(newToggleState);
    setShowActiveUserModal(true);
  }
  const handleUserUpdateModal = (data:any) => {
    setIsEdit(true)
    setShowAddUpdateUserModal(true)
    setUserData(data)
    setSelectedIndividualCheckboxId([])
  }
  const handleUserAddModal = () => {
    setIsEdit(false)
    setShowAddUpdateUserModal(true)
  }
  const handleRefresh = () => {
    refetch()
  }
  const items = [
    {
      label: "Active",
      onClick: () => {
        setShowActiveUserModal(true);
      },
      ToggleButton: <ToggleButton
        onChange={handleToggle}
        id="toggle"
        checked={currentToggleState}
        disableButton={!isAnyCheckboxChecked || isMoreThanOneChecked} />
    },
    // {
    //   label: 'View Details',
    //   tooltipLabel: "View details", icon: svgIcons.eyeIcon,
    //   // onClick: () => togglePopupformViewOnly(true),
    //   onClick: () => {
    //     setViewOnly(true);
    //     setShowAddUpdateUserModal(true);
    //   },
    //   disableButton: !isAnyCheckboxChecked || isMoreThanOneChecked,
    //   // disableButton: selectedRowId?.length > 1 || selectedRowId?.length === 0, disableIcon: svgIcons.noteIcon,
    //   disableIcon: svgIcons.eyeIcon
    // },
    // { label: 'Refresh', tooltipLabel: "Refresh ", icon: <i className="ti ti-refresh-dot" aria-hidden="true"></i>, onClick: () => handleRefresh() },

  ];

  const options1 = [
    { value: 'All Users', label: 'All Users' },
    { value: "Active Users", label: "Active Users" },
    { value: "Inactive Users", label: "Inactive Users" },
    { value: "Active Organization Admin", label: "Active Organization Admin" },
  ];

  const handleCloseModal = () => {
    setShowAddUpdateUserModal(false);
    setViewOnly(false);
    setSelectedItemData({})
    setSelectedIndividualCheckboxId([])
  };

  const handleCloseStatusModal = () => {
    setShowActiveUserModal(false)
    setCurrentToggleState(!currentToggleState)

  };

  const handleRowClicked = (data: any) => {
    handleRowClick(data);
    setIsRowClicked(true);
    if (data?.active === true) {
      setCurrentToggleState(true)
    } else {
      setCurrentToggleState(false)
    }
  }

  // csv data 
  const headers = initialColumnUsers.map(item => ({
    label: item.name,
    key: item.key,
  }));

  const CsvData = allUsersCSV?.result?.value.result?.data?.map((record: Record<string, any>) => {
    const csvRecord: Record<string, any> = {};

    headers?.forEach(header => {
      if (header.key === "team" && Array.isArray(record[header.key])) {
        csvRecord[header.key] = record[header.key]
          .map((teamMember: Record<string, any>) => `${teamMember.id}:${teamMember.name || ""}`)
          .join(", ");
      } else {
        csvRecord[header.key] = record[header.key]?.value ?? record[header.key] ?? "";
      }
    });

    return csvRecord;
  }) || [];



  return (
    <>
      <ErrorBoundary>
        <AddUpdateUserModal
          show={showAddUpdateUserModal}
          handleClose={handleCloseModal}
          data={UserData}
          viewOnly={viewOnly}
          isEdit={isEdit}
          isRowClicked={isRowClicked}
          refetch={refetch}
        />
      </ErrorBoundary>
      <ActiveUserModal
        show={showActiveUserModal}
        handleClose={handleCloseStatusModal}
        data={userData}
        setCurrentToggleState={setCurrentToggleState}
        refetch={refetch}
        handleDelete={handleDelete}
      />
      <FilterModalUser show={showfilterModal} handleClose={handleClosefilterModal} />

      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              <Ribbon
                items={items}
                buttonText="+ Add User"
                disabled={isAnyCheckboxChecked}
                buttonClass="add-popup ribbon-btn "
                onClickbtn={() => handleUserAddModal()}
              />

              {/* /Page Header */}
              <div className="card ">
                <div className="card-body">
                  {/* Search */}
                  <div className="mb-2">
                    <div className="row align-items-center">
                      <div className="col-md-4 col-sm-8">
                        <h4 className="page-title color-red">All Users </h4>
                      </div>
                      <div className="col-md-8">
                        <div className="d-flex gap-2 flex-column flex-md-row justify-content-end">
                          <CSVLink data={CsvData} headers={headers} filename={`Users_List ${formattedDate}.csv`} className="btn btn-light-red d-flex gap-1 align-items-center justify-content-center">
                            <i className="fa fa-file-export" />
                            Export To CSV
                          </CSVLink>
                          {/* <FilterComponent handlefiltermodel={handlefiltermodel} idValue={idValue} /> */}
                          <div>
                            <div className="icon-form">
                              <span className="form-icon">
                                <i className="ti ti-search" />
                              </span>
                              <input
                                type="text"
                                className="form-control min-height"
                                placeholder="Search User"
                                onChange={handleSearchChange}
                              />
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Manage Users List */}
                  {/* <div className="table-responsive custom-table">
                    <Table dataSource={UsertableData} columns={columns} originalData={allTeamsResult} onRowSelect={handleRowSelect} onDoubleClick={handleRowDoubleClick} paginations={true} />
                  </div> */}
                  <div className="table-responsive custom-table">
                    <table className="table datanew dataTable no-footer table-hover">
                      <thead>
                        <tr>
                          <th>
                            {/* <input
                              type="checkbox"
                              className='form-check-input cursor-pointer'
                              checked={isTableHeadChecked}
                              onChange={handleTableHeadChange}
                            /> */}
                          </th>
                          <TableHeading
                            label='UserID'
                            sortedColumn='userID'
                            columnId='userID'
                            sortOrder='desc'
                            key='userId'
                            handleSort={handleSort}
                          />
                          <TableHeading
                            label='NAME'
                            sortedColumn='firstName'
                            columnId='firstName'
                            sortOrder='desc'
                            handleSort={handleSort}
                          />
                          <TableHeading
                            label='EMAIL'
                            sortedColumn='email'
                            columnId='email'
                            sortOrder='desc'
                            handleSort={handleSort}
                          />
                          <TableHeading
                            label='PHONE'
                            sortedColumn='cellPhone'
                            columnId='cellPhone'
                            sortOrder='desc'
                            handleSort={handleSort}
                          />
                          <TableHeading
                            label='TEAMS'
                            // sortedColumn='team'
                            // columnId='team'
                            sortOrder='desc'
                            handleSort={handleSort}
                          />
                          <TableHeading
                            label='STATUS'
                            sortedColumn='active'
                            columnId='active'
                            sortOrder='desc'
                            handleSort={handleSort}
                          />

                        </tr>
                      </thead>
                      <tbody>
                        {!allUserIsloading && <>
                          {allUsers?.result?.value.result?.data?.length > 0 ? (
                            <>
                              {allUsers?.result?.value.result?.data?.map((data: any, index: any) => (
                                <tr key={data?.userAccountId} onClick={() => handleRowClicked(data)} onDoubleClick={() => handleDoubleClick(data)}
                                  className={selectedIndividualCheckboxId.includes(data?.userAccountId) ? 'selected-row' : ''}>
                                  <td>
                                    <div className="d-flex gap-2">
                                      <TextField
                                        type="checkbox"
                                        fieldClass='form-check-input cursor-pointer'
                                        checked={isTableHeadChecked || selectedIndividualCheckboxId.includes(data.userAccountId)}
                                        onChange={(e) => handleCheckItem(e, data)}
                                      />
                                      <div className='cursor-pointer' onClick={() => handleUserUpdateModal(data)}
                                      >
                                        {svgIcons.updateIcon}
                                      </div>
                                    </div>
                                  </td>
                                  <td>{data?.userID}</td>
                                  <td>{data?.firstName} {data?.lastName}</td>
                                  <td>{data?.email}</td>
                                  <td>{data?.cellPhone}</td>
                                  <td className="" style={{ maxWidth: '140px', overflow: 'auto' }}>
                                    {data?.team?.map((team: { id: number, name: string }, index: number) => (
                                      <span
                                        key={team?.id}
                                        style={{
                                          display: 'inline-block',
                                          padding: '2px 6px',
                                          margin: '0 4px 4px 0',
                                          backgroundColor: '#e0e0e0',
                                          borderRadius: '12px',
                                          fontSize: '12px',
                                        }}
                                      >
                                        {team?.name}
                                      </span>
                                    ))}
                                  </td>
                                  <td>
                                    {data?.active === true ? (
                                      <span className="badge badge-pill badge-status bg-soft-success text-success">Active</span>
                                    ) : (
                                      <span className="badge badge-pill badge-status bg-soft-danger text-danger">Inactive</span>
                                    )}
                                  </td>
                                </tr>
                              ))}
                            </>
                          ) :
                            (
                              <tr>
                                <td colSpan={7}>
                                  <NoRecordFound />
                                </td>
                              </tr>
                            )}
                        </>}
                        {allUserIsloading &&
                          <TableLoading />
                        }
                      </tbody>
                    </table>
                  </div>
                  <Pagination
                    onChange={handlePageSizeChange}
                    pageSize={pageSize}
                    onPageChange={handlePageClick}
                    pageCount={allUsers?.result?.value?.result?.totalPages || 0}
                  />

                  {/* /Manage Users List */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  );
};

export default Manageusers;
